module.exports = __webpack_public_path__ + "static/media/who-logo-3.059d9050.png";